import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_ERP_URL,
  timeout: 10000,
});

// request interceptor (optional tapi bagus)
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error)
);

// response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API ERROR:", error);
    return Promise.reject(error);
  }
);

export default api;